import React, { useState, useEffect, useRef } from 'react';
import '../../../../styles/global.css';
import './NiveisDeEnsino.css';

// Import placeholder images (replace with actual images)
import bercarioImg from '../../../../assets/images/bercario.jpg';
import infantilImg from '../../../../assets/images/infantil.jpg';
import fundamentalImg from '../../../../assets/images/fundamental.jpg';
import medioImg from '../../../../assets/images/medio.jpg';

const NiveisDeEnsino = () => {
  // Array of education levels
  const niveis = [
    {
      id: 'bercario',
      title: 'Berçário',
      description: (
        <ul className="nivel-list-todos-niveis">
          <li>Ambiente acolhedor e seguro</li>
          <li>Acesso ao vivo a câmeras de segurança</li>
          <li>Equipe de berçaristas e psicóloga</li>
          <li>Alimentação com nutricionista, livre de alergênicos</li>
        </ul>
      ),
      image: bercarioImg,
      ages: '0 a 2 anos'
    },
    {
      id: 'infantil',
      title: 'Educação Infantil',
      description: (
        <ul className="nivel-list-todos-niveis">
          <li>Horário integral</li>
          <li>Educação bilíngue</li>
          <li>Aulas de corpo e movimento</li>
          <li>Ateliê de artes</li>
        </ul>
      ),
      image: infantilImg,
      ages: '3 a 5 anos'
    },
    {
      id: 'fundamental',
      title: 'Ensino Fundamental',
      description: (
        <ul className="nivel-list-todos-niveis">
          <li>Base sólida para um ensino médio de excelência</li>
          <li>Educação bilíngue</li>
          <li>Desenvolvimento de competências socioemocionais</li>
          <li>Influência ao pensamento crítico</li>
        </ul>
      ),
      image: fundamentalImg,
      ages: '6 a 14 anos'
    },
    {
      id: 'medio',
      title: 'Ensino Médio',
      description: (
        <ul className="nivel-list-todos-niveis">
          <li>Preparação para as primeiras posições no vestibular</li>
          <li>Direcionamento para o mundo profissional</li>
          <li>Recursos de tecnologia Google for Education</li>
          <li>Laboratório de pesquisa e ciências</li>
        </ul>
      ),
      image: medioImg,
      ages: '15 a 17 anos'
    }
  ];

  // State to track the active slide
  const [activeSlide, setActiveSlide] = useState(0);
  // State to track if user has interacted with carousel
  const [userInteracted, setUserInteracted] = useState(false);
  // Ref for the interval timer
  const intervalRef = useRef(null);

  // Function to go to a specific slide
  const goToSlide = (index) => {
    setActiveSlide(index);
    setUserInteracted(true);
    
    // Clear the existing interval
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  // Function to open WhatsApp
  const openWhatsApp = () => {
    const whatsappUrl = `https://tintim.link/whatsapp/82158fca-7f67-4721-83ea-295922f1f94d/2ca3a4cb-474f-4b3b-bcd4-5d7feaea45df`;
    window.open(whatsappUrl, '_blank');
  };

  // Set up auto-rotation when component mounts
  useEffect(() => {
    // Only start auto-rotation if user hasn't interacted
    if (!userInteracted) {
      intervalRef.current = setInterval(() => {
        setActiveSlide((prevSlide) => (prevSlide + 1) % niveis.length);
      }, 3000);
    }

    // Clean up interval on component unmount
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [userInteracted, niveis.length]);

  return (
    <section id="niveis-de-ensino" className="niveis-section-todos-niveis">
      <div className="container">
        <div className="niveis-tabs-todos-niveis">
          {niveis.map((nivel, index) => (
            <button
              key={nivel.id}
              className={`nivel-tab-todos-niveis ${index === activeSlide ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
            >
              {nivel.title}
            </button>
          ))}
        </div>

        <div className="niveis-carousel-todos-niveis">
          {niveis.map((nivel, index) => (
            <div
              key={nivel.id}
              className={`nivel-slide-todos-niveis ${index === activeSlide ? 'active' : ''}`}
            >
              <div className="nivel-grid-todos-niveis">
                <div className="nivel-image-container-todos-niveis">
                  <img src={nivel.image} alt={nivel.title} className="nivel-image-todos-niveis" />
                </div>
                <div className="nivel-content-todos-niveis" style={{ display: 'flex', flexDirection: 'column' }}>
                  <h3>{nivel.title}</h3>
                  <span className="nivel-ages-todos-niveis">{nivel.ages}</span>
                  <p>{nivel.description}</p>
                  <div className="nivel-cta-todos-niveis">
                    <button 
                      className="hero-whatsapp-button-todos-niveis"
                      onClick={openWhatsApp}
                    >
                      <span className="whatsapp-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="20" height="20" fill="currentColor">
                          <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/>
                        </svg>
                      </span>
                      Agendar visita
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NiveisDeEnsino; 